import { Button, Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { t } from 'i18next';
import { useCallback, useRef } from 'react';

import { useAutoFocus } from '$shared/custom-hooks/useAutoFocus';

import { useContactSupport } from '$components/chat-bot/useContactSupport';

export interface ErrorDeleteRetryDialogProps {
  onTryAgain: () => void;
  isOpen?: boolean;
  onClose: () => void;
  title: string;
  message: string;
}

export function ErrorDeleteRetryDialog({
  onTryAgain,
  isOpen,
  onClose,
  title,
  message,
}: ErrorDeleteRetryDialogProps) {
  const handleContactSupport = useContactSupport(onClose);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (!open) {
        onClose();
      }
    },
    [onClose],
  );

  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useAutoFocus(closeButtonRef);

  return (
    <Dialog
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      className="w-max-4xl"
      hideCloseButton={false}
    >
      <div className="flex flex__dir--column flex__ai--center text-align-center">
        <Icon
          name="failed"
          className="bg-red-500 m-bottom-xxl"
          size={IconSizeClasses.XLarge}
        />
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description className="m-bottom-xxs">{message}</Dialog.Description>
        <p className="m-top-xl">
          <span>{t('errors.contactSupport')} </span>
          <Dialog.Close>
            <button
              type="button"
              onClick={handleContactSupport}
              className="btn-as-link font-weight-regular color-blue-500"
            >
              {t('errors.contactSupport2')}
            </button>
          </Dialog.Close>
        </p>
      </div>
      <Dialog.Actions className="m-top-xxl">
        <Button onClick={onTryAgain} variant="secondary">
          {t('shared.tryAgain')}
        </Button>

        <Dialog.Close>
          <Button ref={closeButtonRef} className="btn--solid">
            {t('shared.close')}
          </Button>
        </Dialog.Close>
      </Dialog.Actions>
    </Dialog>
  );
}
